export const INSTRUCTIONAL_TEXT_STYLE_TYPES = {
    MODAL: 'MODAL',
    PARAGRAPH: 'PARAGRAPH'
};